import { DataProvider, useDataValue } from 'Simple/Data.js'
import { email as isValidEmail } from 'Data/validate.js'
import {
  notifyError,
  notifyInvalid,
  useNotifications,
} from 'Logic/Notifications.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import mutation from './mutation.graphql.js'
import React, { useMemo } from 'react'
import View from './view.js'

export default function Logic(props) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  let dataEmail = useDataValue({
    context: 'flow_shortcuts',
    path: 'email',
    viewPath: props.viewPath,
  })

  let value = useMemo(
    () => ({ email: dataEmail || '' }),
    [] // eslint-disable-line
  ) // ignore dataEmail

  return (
    <DataProvider
      viewPath={props.viewPath}
      context="signup"
      value={value}
      onSubmit={onSubmit}
    >
      <View viewPath={props.viewPath} />
    </DataProvider>
  )

  async function onSubmit({ value: next }) {
    if (isInvalid(next, notify)) return true

    let mutationResponse = await executeMutation(next, {
      fetchOptions: {
        headers: {
          'x-hasura-role': 'public',
        },
      },
    })

    if (
      mutationResponse.error ||
      !mutationResponse.data.auth_patient_invite.ok
    ) {
      return notify(
        notifyError(
          `There was a problem processing your request. Please contact your clinic.`
        )
      )
    }

    setFlowTo(normalizePath(props.viewPath, '../SignUpInviteSent'))
  }

  function isInvalid(next, notify) {
    let list = [!isValidEmail(next.email) && 'email'].filter(Boolean)

    if (list.length > 0) {
      notify(notifyInvalid(list))
      return true
    }
    return false
  }
}
